// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // API entities для дерева
  advertisers: '/ads/tree/advertisers',
  campaigns: '/ads/tree/campaigns',
  insertionOrders: '/ads/tree/insertion-orders',
  lineItems: '/ads/tree/line-items',
  creatives: '/ads/tree/creatives',
  
  // Tree data
  treeData: '/ads/tree',
  
  // Sync status
  syncStatus: '/ads/tree/sync-status',
};
